// mutations
const SET_PAGINATIONSTEP = (state, payload) => {
  state.stepIndex = payload;
};
const SET_EDITFIELD = (state, payload) => {
  state.showEdit = payload;
};
const SET_TEMPUSERINFORMATION = (state, payload) => {
  state.tempUser = payload;
};
const SET_TEMPPAYMENT = (state, payload) => {
  state.tempPayment = payload;
};
const SET_TEMPBANK = (state, payload) => {
  state.tempBank = payload;
};
const SET_RESULTGRADE = (state, payload) => {
  state.resultGrade = payload;
};
const SET_RESULTCOSTCENTER = (state, payload) => {
  state.resultCostCenter = payload;
};
const SET_RESULTWORKLOCATION = (state, payload) => {
  state.resultWorkLoc = payload;
};
const SET_TEMPOTHERINFO = (state, payload) => {
  state.tempOther = payload;
};
const SET_RESUTKARYAWAN = (state, payload) => {
  state.resultKaryawan = payload;
};
const SET_IDUSER = (state, payload) => {
  state.idUser = payload;
};
const SET_RESEMP = (state, payload) => {
  state.resEmp = payload;
};
const SET_RESCEKUSER = (state, payload) => {
  state.cekUser = payload;
};
const SET_USERNAME = (state, payload) => {
  state.username = payload;
};
const SET_RESRELIGIONS = (state, payload) => {
  state.religions = payload;
};
const SET_MARITAL = (state, payload) => {
  state.marital_status = payload;
};
const SET_RESIGNTYPE = (state, payload) => {
  state.list_resign_type = payload;
};
const SET_TEMPJOB = (state, payload) => {
  state.temp_job = payload;
};
const SET_RESULTROLE = (state, payload) => {
  state.resultRole = payload;
};
const SET_PARAMS = (state, payload) => {
  state.params = payload;
};
const SET_TAX_DLL = (state, payload) => {
  state.tax_dll = payload;
};
export default {
  SET_TAX_DLL,
  SET_IDUSER,
  SET_RESUTKARYAWAN,
  SET_PAGINATIONSTEP,
  SET_EDITFIELD,
  SET_TEMPUSERINFORMATION,
  SET_TEMPPAYMENT,
  SET_TEMPBANK,
  SET_RESULTGRADE,
  SET_RESULTCOSTCENTER,
  SET_RESULTWORKLOCATION,
  SET_TEMPOTHERINFO,
  SET_RESCEKUSER,
  SET_USERNAME,
  SET_RESRELIGIONS,
  SET_MARITAL,
  SET_RESIGNTYPE,
  SET_TEMPJOB,
  SET_RESULTROLE,
  SET_RESEMP,
  SET_PARAMS
};
